/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Types of documents that can be uploaded.
 */
export const DocumentType = {
  DriversLicense: "driversLicense",
  Passport: "passport",
  UtilityBill: "utilityBill",
  BankStatement: "bankStatement",
} as const;
/**
 * Types of documents that can be uploaded.
 */
export type DocumentType = ClosedEnum<typeof DocumentType>;

/** @internal */
export const DocumentType$inboundSchema: z.ZodNativeEnum<typeof DocumentType> =
  z.nativeEnum(DocumentType);
/** @internal */
export const DocumentType$outboundSchema: z.ZodNativeEnum<typeof DocumentType> =
  DocumentType$inboundSchema;
